/* Applicability: the reasons behind a filing's position. Tokens only (ADR-0007). */

.sub {
  color: var(--muted);
  font-size: var(--t-min);
}

.link {
  color: var(--accent);
  background: none;
  border: 0;
  padding: 0;
  font: inherit;
  cursor: pointer;
  text-decoration: underline;
}

.assuranceList {
  display: flex;
  gap: 8px;
}

.assurance {
  display: inline;
  font-size: var(--t-min);
  white-space: nowrap;
}

.reason {
  display: flex;
  gap: 7px;
  padding: 5px 0 0;
  align-items: flex-start;
  max-width: 92ch;
}

.mark {
  flex: 0 0 auto;
  margin-top: 2px;
  color: var(--ink-2);
}

.markOff {
  color: var(--muted);
}

.markMissing {
  color: var(--warn);
}

.cite {
  display: block;
  color: var(--muted);
  font-size: var(--t-min);
  margin-top: 1px;
  max-width: 92ch;
}

.cite > a {
  color: var(--muted);
}

/* A dispute is shown, not alarmed about: the statute and the regulation measure one thing two ways,
   and saying so is the product being honest rather than the product being in trouble. */
.dispute {
  display: block;
  margin-top: 3px;
  padding: 1px 0 1px 8px;
  border-left: 2px solid var(--line-2);
  color: var(--ink-2);
  font-size: var(--t-min);
  max-width: 92ch;
}

/* One fact of the drawer: the date and the support level, each with the server's own sentence. */
.fact {
  margin: 6px 0 0;
  max-width: 92ch;
  color: var(--ink-2);
}
